import React, { useEffect, useState } from "react";
import { GenericInfoPopup, Icon, IconName, useDeviceTypes } from "halifax";
import { GO_BACK_BUTTON } from "@capone/common";
import {
  ModalButtonType,
  ModalCategoryType,
  ModalScreens,
  MODAL_ALERT,
} from "redmond";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import {
  GENERIC_ERROR_TITLE,
  GENERIC_ERROR_TRY_AGAIN_SUBTITLE,
  TRY_AGAIN_CTA_TEXT,
} from "../../../../../../packages-module/src/modules/book/components/BookingErrorModal/textConstants";

export interface VibesErrorModalProps {
  hasFailed: boolean;
  onRetry: () => void;
  onGoBack: () => void;
}

export const VibesErrorModal: React.FC<VibesErrorModalProps> = ({
  hasFailed,
  onRetry,
  onGoBack,
}) => {
  const { matchesMobile } = useDeviceTypes();
  const [isOpen, setIsOpen] = useState(false);
  const subtitle = GENERIC_ERROR_TRY_AGAIN_SUBTITLE;

  const modalEventProperties = {
    type: "premium_stays_vibes_error",
    primary_button: TRY_AGAIN_CTA_TEXT,
    secondary_button: GO_BACK_BUTTON,
    screen: ModalScreens.PREMIUM_STAYS_LANDING,
    category: ModalCategoryType.TROUBLE,
    modal_subtitle: subtitle,
    modal_title: GENERIC_ERROR_TITLE,
  };

  useEffect(() => {
    if (hasFailed) {
      setIsOpen(true);
      trackEvent({
        eventName: MODAL_ALERT,
        properties: { ...modalEventProperties },
      });
    }
  }, [hasFailed]);

  const handleRetry = () => {
    setIsOpen(false);
    trackEvent({
      eventName: MODAL_ALERT,
      properties: {
        ...modalEventProperties,
        button_choice: ModalButtonType.PRIMARY,
      },
    });
    onRetry();
  };

  const handleGoBack = () => {
    setIsOpen(false);
    trackEvent({
      eventName: MODAL_ALERT,
      properties: {
        ...modalEventProperties,
        button_choice: ModalButtonType.SECONDARY,
      },
    });
    onGoBack();
  };

  return (
    <GenericInfoPopup
      className="vibes-error-modal-root"
      open={isOpen}
      image={<Icon className="error-icon" name={IconName.ErrorState} />}
      title={GENERIC_ERROR_TITLE}
      subtitle={subtitle}
      buttons={[
        { buttonText: TRY_AGAIN_CTA_TEXT, onClick: handleRetry },
        {
          buttonText: GO_BACK_BUTTON,
          onClick: handleGoBack,
          defaultStyle: "h4r-secondary",
        },
      ]}
      isMobile={matchesMobile}
    />
  );
};
